// Routes owned by the Reseller module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const resellerPaths = {
    // Resellers
    resellersList: '/resellers',
    resellerCreate: '/resellers/new',
    resellerDetail: '/resellers/:id',
} as const
